import { render, staticRenderFns } from "./ProductContentChaptersHighlights.vue?vue&type=template&id=0ae74ad5&scoped=true"
import script from "./ProductContentChaptersHighlights.vue?vue&type=script&lang=js"
export * from "./ProductContentChaptersHighlights.vue?vue&type=script&lang=js"
import style0 from "./ProductContentChaptersHighlights.vue?vue&type=style&index=0&id=0ae74ad5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae74ad5",
  null
  
)

export default component.exports